import axios from 'axios'
import React, { useState, useEffect } from 'react'
import { ToastContainer } from 'react-toastify'
import { BASE_URL } from '../../config/axios'
import { AddSubActivity, DeleteSubActivity, UpdateSubActivity } from './AddSubActivity'



const SubActivtiy = () => {
    const [subActivity, setSubActivity] = useState([]);

    const getSubActivity = async () => {
        try {
            const result = await axios.get(`${BASE_URL}/detail-design/subactivity/`);
            setSubActivity(result.data);
        } catch (err) {
            console.error("Error fetching sub-activities:", err);
        }
    };

    useEffect(() => {
        getSubActivity();
    }, []);

    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <div className="content-tabs">
                <div className="attendance-box">
                    <div className="attendance-subcont-01">
                        <div className="field-cont">
                            <div className="field-cont-div"></div>
                        </div>

                        <div className="btn-cont">
                            <AddSubActivity getSubActivity={getSubActivity} />
                        </div>
                    </div>

                    <div className="datagrid-container">
                        <div className="table-css-white-background table-box scroll-container-table">
                            <table className="table-css">
                                <thead className="table-heading">
                                    <tr className="custom-table-head-tr">
                                        <th className="table-heading-text">Sr no.</th>
                                        <th className="table-heading-text text-center" style={{ padding: "30px 162px" }}>
                                            Sub-Activity Code
                                        </th>
                                        <th className="table-heading-text text-center" style={{ padding: "30px 162px" }}>
                                            Sub-Activity Name
                                        </th>
                                        <th className="table-heading-text text-end" style={{ paddingRight: '50px' }}>
                                            Action
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {subActivity.length > 0 ? (
                                        subActivity.map((i, index) => (
                                            <tr key={i.id || index} className="custom-table-head-td">
                                                <td className="table-body">{index + 1}</td>
                                                <td className="table-body text-center">{i.subactivity_code}</td>
                                                <td className="table-body text-center">{i.subactivity_name}</td>
                                                <td className="table-body text-left">
                                                    <div className="flex-row" style={{ justifyContent: 'end' }}>
                                                        <UpdateSubActivity i={i} getSubActivity={getSubActivity} />
                                                        <DeleteSubActivity i={i} getSubActivity={getSubActivity} />
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="4" className="text-center">
                                                No Sub-Activity Found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};


export default SubActivtiy
